import React from "react";

export default function AdvertisePage() {
  return (
    <div className="advertise-page">
      <div className="inner-page">
        <h1>Get Seen by 222,000+ Monthly Visitors</h1>
        <p
          style={{
            fontSize: "1.3em",
            color: "#888",
            marginBottom: "15px",
            lineHeight: "1.15",
          }}
        >
          For Half the Cost of Facebook & Instagram Ads
        </p>
        <div className="contact">
          <span>Reach out to us at</span>
          <div className="email-container" onClick="copyEmail(this)">
            <span className="email-text">support@toktools.com</span>
            <svg className="copy-icon" fill="currentColor" viewBox="0 0 24 24">
              <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
            </svg>
          </div>
        </div>

        <p
          style={{
            marginBottom: "15px",
            marginTop: "20px",
            fontSize: "1.05em",
            textAlign: "center",
          }}
        >
          Transparent pricing. No guessing, no hidden fees.
        </p>

        <table>
          <tr>
            <th>Impressions</th>
            <th>CPM</th>
            <th>Price</th>
          </tr>
          <tr>
            <td>100,000</td>
            <td>$4.00</td>
            <td>$400</td>
          </tr>
          <tr>
            <td>250,000</td>
            <td>$3.60</td>
            <td>$900</td>
          </tr>
          <tr>
            <td>500,000</td>
            <td>$3.20</td>
            <td>$1,600</td>
          </tr>
        </table>

        <p className="trust-text">
          Trusted daily by Fortune 100 companies, top-tier influencers, and the
          brands you recognize
        </p>

        <p className="intro" style={{ marginBottom: "20px" }}>
          Reach <strong>222,000+ unique monthly visitors</strong> generating{" "}
          <strong>336,000+ pageviews</strong>. Connect with the world's largest
          influencers, Fortune 100 employees, TikTok creators, developers, and
          decision-makers all in one campaign.
        </p>

        <div className="section-divider"></div>

        <h2>Getting started is simple. Just send us:</h2>
        <ol>
          <li>A short brand description</li>
          <li>Creative assets (logos, images, etc.)</li>
          <li>Your preferred campaign start date</li>
          <li>Your payment option</li>
        </ol>

        <p className="payment-note">
          If everything looks good, we can finalize the payment through{" "}
          <strong>Stripe</strong>. We'll work directly with you to ensure a
          smooth and effective advertising experience.
        </p>

        <div
          className="contact"
          style={{ marginTop: "10px", marginBottom: "22px" }}
        >
          <span>Reach out to us at</span>
          <div className="email-container" onClick="copyEmail(this)">
            <span className="email-text">support@toktools.com</span>
            <svg className="copy-icon" fill="currentColor" viewBox="0 0 24 24">
              <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
            </svg>
          </div>
        </div>

        <div className="section-divider"></div>

        <h2>Why Advertise with TokComment?</h2>
        <p style={{ marginBottom: "18px" }}>
          Your ads appear where influencers, Fortune 500s, brands, content
          creators, and startups come every day to get their work done.
          TokComment is their trusted one-stop solution — a place they return to
          daily.
        </p>

        <h2>Who You'll Reach</h2>
        <ul style={{ marginBottom: "22px" }}>
          <li>✔ Creators & Influencers</li>
          <li>✔ Developers & Tech Teams</li>
          <li>✔ E-commerce & TikTok Brands</li>
          <li>✔ B2B & Enterprise Buyers</li>
          <li>✔ Agencies & Innovation Labs</li>
        </ul>

        <div className="section-divider"></div>

        <h2>Cost Comparison: TokComment vs. Facebook, Instagram, Google</h2>
        <p style={{ marginBottom: "12px" }}>
          Here's how TokComment stacks up against the giants:
        </p>
        <div className="comparison-table">
          <table>
            <tr>
              <th>Impressions</th>
              <th>TokComment CPM</th>
              <th>Facebook CPM</th>
              <th>Instagram CPM</th>
              <th>Google Display Ads CPM</th>
              <th>Google Search Ads CPM</th>
            </tr>
            <tr>
              <td>100,000</td>
              <td>$4.00</td>
              <td>
                $9.30 (+ <span className="red">▲ 133%</span>)
              </td>
              <td>
                $7.78 (+ <span className="red">▲ 95%</span>)
              </td>
              <td>
                $7.50 (+ <span className="red">▲ 88%</span>)
              </td>
              <td>
                $50.60 (+ <span className="red">▲ 1165%</span>)
              </td>
            </tr>
            <tr>
              <td>250,000</td>
              <td>$3.60</td>
              <td>
                $9.30 (+ <span className="red">▲ 158%</span>)
              </td>
              <td>
                $7.78 (+ <span className="red">▲ 116%</span>)
              </td>
              <td>
                $7.50 (+ <span className="red">▲ 108%</span>)
              </td>
              <td>
                $50.60 (+ <span className="red">▲ 1306%</span>)
              </td>
            </tr>
            <tr>
              <td>500,000</td>
              <td>$3.20</td>
              <td>
                $9.30 (+ <span className="red">▲ 191%</span>)
              </td>
              <td>
                $7.78 (+ <span className="red">▲ 143%</span>)
              </td>
              <td>
                $7.50 (+ <span className="red">▲ 134%</span>)
              </td>
              <td>
                $50.60 (+ <span className="red">▲ 1481%</span>)
              </td>
            </tr>
          </table>
        </div>

        <div className="section-divider"></div>

        <h2>Perfect for These Advertisers</h2>
        <p style={{ marginBottom: "25px" }}>
          If you're building for creators, brands, or tech teams — TokComment is
          built for you.
        </p>

        <div className="section-divider"></div>

        <h2 style={{ marginBottom: "25px" }}>
          Save 5–15x Compared to Instagram, Facebook, and Google Ads
        </h2>

        <div className="section-divider"></div>

        <h2 style={{ marginTop: "30px" }}>What You Get with TokComment</h2>
        <ul style={{ marginBottom: "25px" }}>
          <li>
            Premium audience quality — trusted by Fortune 100s & top creators
          </li>
          <li>336,000+ monthly pageviews</li>
          <li>Repeat, high-frequency visitors</li>
          <li>Diverse mix: creators, developers, brands, enterprises</li>
          <li>Real-time reporting on every campaign</li>
        </ul>

        <div className="section-divider"></div>

        <p className="footer" style={{ marginTop: "35px" }}>
          Ready to reach the right audience for less? Let's launch your campaign
          today. <span className="rocket">🚀</span>
        </p>
        <div
          className="contact"
          style={{ marginTop: "10px", marginBottom: "20px" }}
        >
          <span>Contact us at</span>
          <div className="email-container" onClick="copyEmail(this)">
            <span className="email-text">support@toktools.com</span>
            <svg className="copy-icon" fill="currentColor" viewBox="0 0 24 24">
              <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}
